import React, { useEffect, useState } from "react";
import HeaderSubmission from "./HeaderSubmission/HeaderSubmission";
import Project from "../Projects/Project";
import { submissionsApi } from '../../../utils'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";


const Submission = () => {

    const [data, setData] = useState()
    const [scoreAdditionalData, setScoreAdditionalData] = useState()
    const [nameStatus, setNameStatus] = useState()
    let { submissionId } = useParams();
    
    const { texts, lang } = useSelector(state => state.translate);
    const dispatch = useDispatch()

    useEffect(() => {
        const submissionsFilter = {
            submissionId,
            showPendingMsg: true,
        }
        submissionsApi.submissionsFilterPost({ submissionsFilter }, (error, resdata, response) => {
            if (error)
                dispatch(throwApiError({ userMessage: texts.submissionsFilterIdError, error: error, statusCode: response?.statusCode, message: "submissionsFilterIdPost " + error.message, level: 2, component: "Submission", line: 22 }))
            else {
                const newbody = response.body
                if (response.body.contentData) {
                    const newAdditionalData = JSON.parse(newbody.contentData)
                    newbody.contentData = newAdditionalData
                }
                setData({ ...newbody });
            }
        })

    }, [submissionId])

    useEffect(() => {
        if (data) {
            const newData = data;
            const newScore = JSON.stringify(scoreAdditionalData?.score);
            newData.scoreAdditionalData = newScore;
            newData.remarks = scoreAdditionalData.remarks;
            setData({ ...newData })
        }
    }, [scoreAdditionalData])

    useEffect(() => {
        if (data) {
            const newData = data;
            newData.submissionStatusId = nameStatus;
            setData({ ...newData })
        }
    }, [nameStatus])

    return (
        <>
            {data && <>
                <HeaderSubmission data={data} setData={setData} />
                <Project attachmentUrl={`${data.attachmentUrl}`} ideUrl={data.ide?.url} ideConfig={data.ide?.additionalConfiguration} height="calc(100vh - 135px)" IdeLang={data.ide?.lang ? data.ide?.lang : lang}></Project>
            </>}
        </>
    )
}

export default Submission;